import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c(
        VContainer,
        [
          _c("p", [_vm._v(_vm._s(_vm.$t("attributes.managment.label.add")))]),
          _c(
            VForm,
            {
              ref: "form",
              staticClass: "form",
              attrs: { "lazy-validation": "" },
              model: {
                value: _vm.valid,
                callback: function ($$v) {
                  _vm.valid = $$v
                },
                expression: "valid",
              },
            },
            [
              _c(
                VRow,
                { attrs: { "no-gutters": "" } },
                [
                  _c(
                    VCol,
                    { attrs: { cols: "6", md: "6" } },
                    [
                      _c(VTextField, {
                        attrs: {
                          outlined: "",
                          dense: "",
                          rules: _vm.rules.name_es,
                          name: "form.name_es",
                          label: _vm.$t("attributes.label.name_es"),
                          placeholder: _vm.$t("attributes.label.name_es"),
                        },
                        model: {
                          value: _vm.form.name_es,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "name_es", $$v)
                          },
                          expression: "form.name_es",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "6", md: "6" } },
                    [
                      _c(VTextField, {
                        staticClass: "pl-0 pl-md-1",
                        attrs: {
                          outlined: "",
                          dense: "",
                          rules: _vm.rules.name_en,
                          name: "form.name_en",
                          label: _vm.$t("attributes.label.name_en"),
                          placeholder: _vm.$t("attributes.label.name_en"),
                        },
                        model: {
                          value: _vm.form.name_en,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "name_en", $$v)
                          },
                          expression: "form.name_en",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "6", md: "6" } },
                    [
                      _c(VTextarea, {
                        attrs: {
                          outlined: "",
                          rows: "2",
                          dense: "",
                          rules: _vm.rules.description_es,
                          name: "form.description_es",
                          label: _vm.$t("attributes.label.description_es"),
                          placeholder: _vm.$t(
                            "attributes.label.description_es"
                          ),
                        },
                        model: {
                          value: _vm.form.description_es,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "description_es", $$v)
                          },
                          expression: "form.description_es",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "6", md: "6" } },
                    [
                      _c(VTextarea, {
                        staticClass: "pl-0 pl-md-1",
                        attrs: {
                          outlined: "",
                          rows: "2",
                          dense: "",
                          rules: _vm.rules.description_en,
                          name: "form.description_en",
                          label: _vm.$t("attributes.label.description_en"),
                          placeholder: _vm.$t(
                            "attributes.label.description_en"
                          ),
                        },
                        model: {
                          value: _vm.form.description_en,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "description_en", $$v)
                          },
                          expression: "form.description_en",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "10", md: "10" } },
                    [
                      _c(VFileInput, {
                        attrs: {
                          accept: "image/*",
                          label: _vm.$t("attributes.label.icon"),
                          outlined: "",
                          dense: "",
                        },
                        on: { change: _vm.onFileChanged },
                        model: {
                          value: _vm.files,
                          callback: function ($$v) {
                            _vm.files = $$v
                          },
                          expression: "files",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "2", md: "2" } },
                    [
                      _c(VImg, {
                        staticClass: "pl-0 pl-md-1",
                        attrs: {
                          "lazy-src": _vm.form.attribute_group_design,
                          "max-height": "55",
                          "max-width": "55",
                          src: _vm.form.attribute_group_design,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "6", md: "6" } },
                    [
                      _c(VTextField, {
                        attrs: {
                          readonly: true,
                          filled: "",
                          dense: "",
                          outlined: "",
                          rules: _vm.rules.attribute_project_name,
                          name: "form.attribute_project_name",
                          label: _vm.$t(
                            "attributes.label.attribute_project_name"
                          ),
                          placeholder: _vm.$t(
                            "attributes.label.attribute_project_name"
                          ),
                        },
                        model: {
                          value: _vm.form.attribute_project_name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "attribute_project_name", $$v)
                          },
                          expression: "form.attribute_project_name",
                        },
                      }),
                      _c(VTextField, {
                        attrs: {
                          readonly: true,
                          filled: "",
                          dense: "",
                          outlined: "",
                          rules: _vm.rules.attribute_object_name,
                          name: "form.attribute_object_name",
                          label: _vm.$t(
                            "attributes.label.attribute_object_name"
                          ),
                          placeholder: _vm.$t(
                            "attributes.label.attribute_object_name"
                          ),
                        },
                        model: {
                          value: _vm.form.attribute_object_name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "attribute_object_name", $$v)
                          },
                          expression: "form.attribute_object_name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "6", md: "6" } },
                    [
                      _c(VTextField, {
                        staticClass: "pl-0 pl-md-1",
                        attrs: {
                          readonly: true,
                          filled: "",
                          dense: "",
                          outlined: "",
                          rules: _vm.rules.attribute_scheme_name,
                          name: "form.attribute_scheme_name",
                          label: _vm.$t(
                            "attributes.label.attribute_scheme_name"
                          ),
                          placeholder: _vm.$t(
                            "attributes.label.attribute_scheme_name"
                          ),
                        },
                        model: {
                          value: _vm.form.attribute_scheme_name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "attribute_scheme_name", $$v)
                          },
                          expression: "form.attribute_scheme_name",
                        },
                      }),
                      _c(VTextField, {
                        staticClass: "pl-0 pl-md-1",
                        attrs: {
                          outlined: "",
                          dense: "",
                          rules: _vm.rules.alias,
                          name: "form.alias",
                          label: _vm.$t("attributes.label.alias"),
                          placeholder: _vm.$t("attributes.label.alias"),
                        },
                        model: {
                          value: _vm.form.alias,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "alias", $$v)
                          },
                          expression: "form.alias",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("segment-tables-component", {
            ref: "tablesComponent",
            attrs: { "is-attributes": true },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }